/* shah */
import React from 'react'

const ReadingGuideIcon = () => {
    return (
        <svg id="SmallBoxSVG-learning" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M638 4546 c-60 -16 -120 -58 -159 -110 -62 -85 -60 -8 -57 -1512 l3
-1369 21 -46 c28 -60 87 -119 150 -150 l49 -24 765 0 c704 0 769 1 815 18 105
36 207 141 242 246 17 53 18 119 18 1321 l0 1265 -22 57 c-62 162 -187 272
-351 307 -79 17 -1410 14 -1474 -3z m1219 -628 c29 -27 30 -71 3 -98 -19 -19
-33 -20 -404 -20 -351 0 -386 1 -404 18 -32 27 -33 71 -2 102 19 19 33 20 402
20 378 0 382 0 405 -22z m309 -351 c31 -36 30 -62 -1 -92 l-24 -25 -686 0
-686 0 -24 25 c-40 39 -31 89 19 111 25 11 155 13 704 11 l674 -2 24 -28z m-1
-342 c14 -13 25 -31 25 -39 0 -31 -24 -65 -53 -76 -20 -6 -255 -10 -689 -10
-559 0 -663 2 -687 15 -48 24 -55 72 -16 110 l24 25 686 0 686 0 24 -25z
m-775 -345 c26 -26 25 -68 -2 -97 l-21 -23 -301 0 c-294 0 -300 0 -323 22 -29
27 -29 65 -1 95 l21 23 304 0 c290 0 304 -1 323 -20z m779 -346 c27 -35 26
-59 -4 -89 l-24 -25 -687 0 -688 0 -23 22 c-29 27 -29 65 -1 95 l21 23 693 0
693 0 20 -26z m-19 -329 c52 -27 52 -93 0 -120 -25 -13 -119 -15 -694 -15
-410 0 -675 4 -690 10 -55 21 -59 100 -6 127 19 10 177 13 693 13 572 0 672
-2 697 -15z m15 -360 c30 -30 31 -54 4 -89 l-20 -26 -692 0 -691 0 -23 22
c-29 27 -29 65 -1 95 l21 23 689 0 689 0 24 -25z"/>
                <path d="M2995 4546 c-160 -40 -278 -146 -338 -304 l-22 -57 -3 -1239 c-1
-770 1 -1259 7 -1291 20 -108 95 -216 186 -269 96 -57 96 -57 906 -54 l744 3
49 24 c63 31 116 84 147 147 l24 49 0 1390 0 1390 -21 46 c-28 60 -93 125
-153 153 -46 21 -52 21 -761 23 -544 1 -727 -1 -765 -11z m1073 -453 c32 -28
33 -72 2 -103 -19 -19 -33 -20 -402 -20 -378 0 -382 0 -405 22 -29 27 -30 71
-3 98 19 19 33 20 404 20 351 0 386 -1 404 -17z m307 -348 c30 -29 32 -64 6
-96 l-19 -24 -679 -3 c-471 -2 -686 1 -704 8 -57 24 -63 100 -9 127 19 10 179
13 703 13 l678 0 24 -25z m2 -347 c29 -27 29 -65 1 -95 l-21 -23 -693 0 -693
0 -20 26 c-12 15 -21 34 -21 44 0 10 9 29 21 44 l20 26 692 0 691 0 23 -22z
m-18 -333 c48 -24 55 -72 16 -110 l-24 -25 -686 0 -686 0 -24 25 c-38 38 -30
84 20 113 14 8 204 11 688 12 567 0 672 -2 696 -15z m-118 -562 c35 -18 64
-43 84 -71 l30 -44 3 -248 c3 -216 1 -253 -14 -282 -23 -46 -62 -86 -106 -109
-35 -18 -65 -19 -573 -19 -511 0 -538 1 -574 19 -49 26 -97 81 -111 128 -8 25
-10 120 -8 275 l3 236 30 44 c20 28 49 53 84 71 l55 27 521 0 521 0 55 -27z"/>
                <path d="M3134 2366 c-18 -13 -19 -30 -22 -230 l-3 -216 25 -25 25 -25 510 0
510 0 20 26 c20 25 21 39 21 235 0 196 -1 210 -20 229 -19 19 -33 20 -533 20
-427 0 -516 -2 -533 -14z"/>
                <path d="M180 4089 c-54 -24 -124 -90 -153 -144 l-22 -40 0 -1385 0 -1385 23
-42 c32 -60 86 -111 151 -142 l56 -26 2325 0 2325 0 56 26 c65 31 119 82 151
142 l23 42 0 1385 c0 1325 -1 1386 -18 1419 -48 87 -160 171 -229 171 l-28 0
-2 -1292 -3 -1293 -36 -76 c-48 -99 -119 -170 -218 -218 l-76 -36 -779 -3
c-866 -3 -823 -6 -958 65 -62 32 -148 110 -191 173 l-17 24 -17 -24 c-69 -99
-172 -176 -287 -215 l-76 -25 -782 2 -783 3 -69 33 c-90 42 -144 87 -191 158
-80 121 -75 19 -75 1450 l0 1274 -27 0 c-16 0 -48 -10 -73 -21z"/>
                <path d="M1950 772 c0 -12 50 -84 84 -120 17 -19 54 -46 81 -60 l50 -27 395 0
395 0 50 27 c28 14 64 41 81 60 34 36 84 108 84 120 0 5 -274 8 -610 8 -335 0
-610 -3 -610 -8z"/>
            </g>
        </svg>
    )
}

export default ReadingGuideIcon